import { AddToWalletIcon } from '@ankr.com/ui';
import { Box, Button } from '@mui/material';
import { Chain } from '@ankr.com/chains-list';

import { useAccount } from 'modules/account/hooks/useAccount';

import { AddNetworkDialog } from '../AddNetworkDialog';
import { useAddNetworkButton } from './hooks/useAddNetworkButton';
import { useAddNetworkButtonStyles } from './useAddNetworkButtonStyles';

export interface AddNetworkButtonProps {
  chain: Chain;
  hasAddNetworkDialog?: boolean;
  hasPlaceholder?: boolean;
  label?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  size?: 'large' | 'medium' | 'small';
  projectSelector?: React.ReactNode;
  isChainSelectorHidden?: boolean;
}

export const AddNetworkButton = ({
  chain,
  className,
  hasAddNetworkDialog,
  hasPlaceholder,
  isChainSelectorHidden,
  label,
  onClick: onClickExternal,
  projectSelector,
  size = 'small',
}: AddNetworkButtonProps) => {
  const { isAccountInitializing } = useAccount();

  const { closeAddNetworkDialog, isAddNetworkDialogOpened, isHidden, onClick } =
    useAddNetworkButton({
      chain,
      hasAddNetworkDialog,
      onClick: onClickExternal,
    });

  const { classes, cx } = useAddNetworkButtonStyles();

  if (isHidden) {
    if (hasPlaceholder) {
      return <Box className={classes.placeholder} />;
    }

    return null;
  }

  return (
    <>
      <Button
        disabled={isAccountInitializing}
        className={cx(classes.button, className)}
        size={size}
        onClick={onClick}
        variant="outlined"
      >
        <AddToWalletIcon className={classes.icon} size={20} />
        {label}
      </Button>

      {hasAddNetworkDialog && (
        <AddNetworkDialog
          chain={chain}
          isOpened={isAddNetworkDialogOpened}
          onClose={closeAddNetworkDialog}
          projectSelector={projectSelector}
          isChainSelectorHidden={isChainSelectorHidden}
        />
      )}
    </>
  );
};
